import { combineReducers } from 'redux';

import constants from './reducers/constants';
import state from './reducers/state';
import featureFlags from './reducers/featureFlags';
import messageSettings from './reducers/messageSettings';
import isOnline from './reducers/isOnline';
import alertBanner from './reducers/alertBanner';

export default combineReducers({
  constants,
  state,
  featureFlags,
  messageSettings,
  isOnline,
  alertBanner,
});
